import { IServicePackageSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { getPackageId } from './getPackageId';

export function getSelectedPackageId(packages: IServicePackageSchema[]): string | null {
  const paidPackage = packages.find(({ isPaid }) => isPaid);
  const defaultPackage = packages.find(({ isDefault }) => isDefault);
  const firstPackage = packages[0];

  if (paidPackage) {
    return getPackageId(paidPackage);
  }

  if (defaultPackage) {
    return getPackageId(defaultPackage);
  }

  if (firstPackage) {
    return getPackageId(firstPackage);
  }

  return null;
}
